import { createContext } from 'react'


const OwnerContext = createContext<{ ownerStatus: any, setOwnerStatus: any }>({ ownerStatus: null, setOwnerStatus: null });

export const OwnerProvider = OwnerContext.Provider
export const OwnerConsumer = OwnerContext.Consumer

export default OwnerContext
